<div class="editor-add-block" [class.active]="active" (click)="active = true" appClickOutside (clickOutside)="active = false;">
  <div class="add-section">
    <span></span>
    <div>Voeg sectie toe</div>
    <span></span>
  </div>
  @if (active) {
    <div class="types">
      @for (type of types; track type) {
        <div class="type" (click)="addBlock(type.code)"><i class="icon-{{type.code}}"></i><span>{{type.name}}</span></div>
      }
    </div>
  }
</div>